import React, { useState, useEffect } from "react";
import intl from "react-intl-universal";

import { Confirm } from "./Confirm";

export const ExceptionDialog = () => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState("");

    useEffect(() => {
        document.addEventListener("exception", event => {
            const error = event.payload;
            if (error.i18nLabel) {
                setMessage(intl.get("exception." + error.i18nLabel, error.args));
            } else {
                setMessage(intl.get("exception.unknown"));
            }
            setError(error);
            setShow(true);
        }, false);
    }, []);

    const onConfirm = () => {
        setShow(false);
        if (error.status === 401) {
            location.reload();
        }
    };

    return (
        <>
            {show &&
                <Confirm
                    confirmButtonOnly={true}
                    title={intl.get("exception.title")}
                    body={message}
                    confirm={intl.get("common.ok")}
                    onConfirm={() => onConfirm()}
                    onClose={() => onConfirm()} />
            }
        </>
    );
};